// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6f50ce7f","239":"15b76805","453":"c38367e9","455":"99cb167f"}[chunkId] + ".chunk.js";
};